module.exports = __webpack_public_path__ + "img/24-consultas-pagamentos-lista.34e67101.png";